import { render } from "./ViewReports.vue?vue&type=template&id=08e14d51"
import script from "./ViewReports.vue?vue&type=script&lang=js"
export * from "./ViewReports.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__